import React from "react";
import { useParams } from "react-router-dom";
import { SocketContext } from "../context";
import { useSocket } from "../hooks/use-socket";
export const SocketProvider = ({ namespace, children }) => {
    const { uuid } = useParams();
    const socket = useSocket(namespace, { uuid });
    return (React.createElement(SocketContext.Provider, { value: socket }, children));
};
